const STORAGE_KEY = "start-social-progress-v1";
const TASKS_PER_DAY = 3;
const TOTAL_TASKS = 21;

const dayGuidance = [
  { day: 1, title: "Choose who you want to help", text: "Pick one audience, one problem and one useful result. Specific beats everyone." },
  { day: 2, title: "Make your profile clear in 5 seconds", text: "Use your photo, name and bio to show exactly who you help and why someone should follow." },
  { day: 3, title: "Build your first 10 ideas", text: "Use real problems, questions and beginner mistakes instead of waiting for inspiration." },
  { day: 4, title: "Write Hook → Value → CTA", text: "One clear promise, one useful lesson and one next action is enough for your first script." },
  { day: 5, title: "Record without chasing perfection", text: "Good light, clear sound and short sentences matter more than expensive gear." },
  { day: 6, title: "Edit for clarity", text: "Cut mistakes and pauses, add readable captions, and keep every edit useful." },
  { day: 7, title: "Publish and learn", text: "Your first goal is to finish the creator loop, learn one thing and plan video number two." },
];

const state = loadState();
const allCheckboxes = [...document.querySelectorAll("[data-task]")];

function loadState() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return stored && typeof stored === "object" ? { tasks: stored.tasks || {}, form: stored.form || {} } : { tasks: {}, form: {} };
  } catch { return { tasks: {}, form: {} }; }
}

function saveState() { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
function completedCount() { return Object.values(state.tasks).filter(Boolean).length; }
function nextIncompleteDay() {
  for (let day = 1; day <= 7; day += 1) {
    const count = allCheckboxes.filter((box) => box.dataset.task.startsWith(`d${day}-`) && box.checked).length;
    if (count < TASKS_PER_DAY) return day;
  }
  return 7;
}

function updateProgress() {
  const completed = completedCount();
  const percent = Math.round((completed / TOTAL_TASKS) * 100);
  document.querySelector("#progressBar").style.width = `${percent}%`;
  document.querySelector("#progressText").textContent = `${completed} of ${TOTAL_TASKS} tasks`;
  document.querySelector("#headerProgress").textContent = `${percent}%`;
  for (let day = 1; day <= 7; day += 1) {
    const dayBoxes = allCheckboxes.filter((box) => box.dataset.task.startsWith(`d${day}-`));
    const dayDone = dayBoxes.filter((box) => box.checked).length;
    document.querySelector(`[data-day-status="${day}"]`).textContent = `${dayDone}/${TASKS_PER_DAY}`;
    document.querySelector(`[data-day="${day}"]`).classList.toggle("is-complete", dayDone === TASKS_PER_DAY);
  }
  const next = nextIncompleteDay();
  const guidance = dayGuidance[next - 1];
  const allDone = completed === TOTAL_TASKS;
  document.querySelector("#nextMoveTitle").textContent = allDone ? "You finished the challenge" : guidance.title;
  document.querySelector("#nextMoveText").textContent = allDone ? "You built a repeatable creator system. Plan video number two and improve one thing." : guidance.text;
  document.querySelector("#nextMoveButton").textContent = allDone ? "Build my next plan ↗" : `Continue day ${next} ↗`;
  document.querySelector("#nextMoveButton").href = allDone ? "#studio" : `#day-${next}`;
  document.querySelector("#completionCard").hidden = !allDone;
}

function setOpenDay(card, shouldOpen) {
  const toggle = card.querySelector(".day-toggle");
  const panel = card.querySelector(".day-panel");
  card.classList.toggle("is-open", shouldOpen);
  toggle.setAttribute("aria-expanded", String(shouldOpen));
  panel.hidden = !shouldOpen;
}

document.querySelectorAll(".day-toggle").forEach((toggle) => {
  toggle.addEventListener("click", () => {
    const card = toggle.closest(".day-card");
    const open = !card.classList.contains("is-open");
    document.querySelectorAll(".day-card.is-open").forEach((other) => setOpenDay(other, false));
    setOpenDay(card, open);
  });
});

allCheckboxes.forEach((box) => {
  box.checked = Boolean(state.tasks[box.dataset.task]);
  box.addEventListener("change", () => { state.tasks[box.dataset.task] = box.checked; saveState(); updateProgress(); });
});

document.querySelector("#resetProgress").addEventListener("click", () => {
  state.tasks = {};
  allCheckboxes.forEach((box) => { box.checked = false; });
  saveState(); updateProgress(); showToast("Progress reset");
});

const formControls = [...document.querySelectorAll("#ideaForm input, #ideaForm select")];
formControls.forEach((control) => {
  if (state.form[control.name]) control.value = state.form[control.name];
  control.addEventListener("input", () => { state.form[control.name] = control.value; saveState(); });
});

document.querySelectorAll(".practice-jump").forEach((link) => {
  link.addEventListener("click", () => { window.setTimeout(() => document.querySelector("#audience").focus(), 400); });
});

document.querySelector("#ideaForm").addEventListener("submit", (event) => {
  event.preventDefault();
  const track = document.querySelector("#track").value;
  const audience = document.querySelector("#audience").value.trim();
  const topic = document.querySelector("#topic").value.trim();
  const goal = document.querySelector("#goal").value.trim();
  if (!audience || !topic || !goal) {
    const firstEmpty = formControls.find((control) => !control.value.trim());
    firstEmpty.focus(); firstEmpty.setAttribute("aria-invalid", "true"); showToast("Complete all three prompts"); return;
  }
  formControls.forEach((control) => control.removeAttribute("aria-invalid"));
  state.form = { track, audience, topic, goal }; saveState();
  const tidyAudience = lowerFirst(audience);
  const tidyTopic = lowerFirst(topic);
  const tidyGoal = lowerFirst(goal);
  document.querySelector("#positioningOutput").textContent = `I help ${tidyAudience} with ${tidyTopic} so they can ${tidyGoal}.`;
  const ideas = [
    `3 mistakes ${tidyAudience} make when starting with ${tidyTopic}`,
    `The simplest first step to ${tidyGoal}`,
    `What I wish I knew before starting with ${tidyTopic}`,
    `A beginner checklist for ${tidyTopic}`,
    `Stop doing this if you want to ${tidyGoal}`,
    `One myth about ${tidyTopic} that wastes beginners' time`,
    `How a ${track} can start with ${tidyTopic} using what they already have`,
    `Answer this beginner question: How do I start with ${tidyTopic}?`,
    `Behind the scenes: how I approach ${tidyTopic}`,
    `A 30-second plan for ${tidyAudience} who want to ${tidyGoal}`,
  ];
  document.querySelector("#ideasOutput").innerHTML = ideas.map((idea) => `<li>${escapeHtml(idea)}</li>`).join("");
  const pillars = [["Teach", `Simple lessons about ${tidyTopic}`],["Show", `Your process as a ${track}`],["Trust", `Proof and lessons for ${tidyAudience}`]];
  document.querySelector("#pillarsOutput").innerHTML = pillars.map(([name, description]) => `<span><b>${escapeHtml(name)}</b><em>${escapeHtml(description)}</em></span>`).join("");
  document.querySelector("#hookOutput").textContent = `If you want to ${tidyGoal}, don’t make this beginner mistake.`;
  document.querySelector("#valueOutput").textContent = `Explain one common mistake, show one simple fix, and give a quick example from ${tidyTopic}.`;
  document.querySelector("#planResult").hidden = false;
  document.querySelector("#planResult").scrollIntoView({ behavior: "smooth", block: "nearest" });
});

document.querySelector("#copyPlan").addEventListener("click", async () => {
  const text = buildPlanText();
  try { await navigator.clipboard.writeText(text); showToast("Plan copied"); } catch { showToast("Select and copy your plan"); }
});

document.querySelector("#downloadPlan").addEventListener("click", () => {
  const file = new Blob([buildPlanText()], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(file); const link = document.createElement("a");
  link.href = url; link.download = "my-start-social-video-plan.txt"; document.body.appendChild(link); link.click(); link.remove(); URL.revokeObjectURL(url); showToast("Plan downloaded");
});

function buildPlanText() {
  return ["POSITIONING", document.querySelector("#positioningOutput").textContent, "", "10 VIDEO IDEAS", ...[...document.querySelectorAll("#ideasOutput li")].map((item, index) => `${index + 1}. ${item.textContent}`), "", "CONTENT PILLARS", ...[...document.querySelectorAll("#pillarsOutput span")].map((item) => `- ${item.textContent}`), "", "QUICK SCRIPT", `Hook: ${document.querySelector("#hookOutput").textContent}`, `Value: ${document.querySelector("#valueOutput").textContent}`, "CTA: Follow for practical, beginner-friendly tips."].join("\n");
}
function lowerFirst(value) { return value.charAt(0).toLowerCase() + value.slice(1).replace(/[.!?]+$/, ""); }
function escapeHtml(value) { const div = document.createElement("div"); div.textContent = value; return div.innerHTML; }
let toastTimer;
function showToast(message) { const toast = document.querySelector("#toast"); toast.textContent = message; toast.classList.add("is-visible"); window.clearTimeout(toastTimer); toastTimer = window.setTimeout(() => toast.classList.remove("is-visible"), 1800); }
updateProgress();